<template>
    <article class="nyk-basic-card">
        <slot />
    </article>
</template>